import { render, staticRenderFns } from "./modification.vue?vue&type=template&id=153f9938&scoped=true"
import script from "./modification.vue?vue&type=script&lang=js"
export * from "./modification.vue?vue&type=script&lang=js"
import style0 from "./modification.vue?vue&type=style&index=0&id=153f9938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f9938",
  null
  
)

export default component.exports